import React, {FC} from 'react';

interface BPaginateProps {
    pageIndex: number;
    onChange: (pageIndex: any) => void;
}

const BPaginate: FC<BPaginateProps> = ({pageIndex, onChange}) => {

    return (
        <div className="bs-pagination">
            <div className="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
                {pageIndex !== 0 && <div className="btn-group me-2" role="group" aria-label="First group">
                    <button type="button" className="btn btn-outline-primary" onClick={() => onChange(0)}>First</button>
                </div>}
                <div className="btn-group me-2" role="group" aria-label="First group">
                    <button type="button" className="btn btn-outline-primary" onClick={() => onChange(pageIndex - 1)} disabled={pageIndex === 0}><i
                        className="bi bi-chevron-left"></i></button>
                </div>
                <div className="btn-group me-2" role="group" aria-label="Second group">
                    <button type="button" className="btn btn-outline-secondary">{pageIndex + 1}</button>
                </div>
                <div className="btn-group" role="group" aria-label="Third group">
                    <button type="button" className="btn btn-outline-primary" onClick={() => onChange(pageIndex + 1)}><i className="bi bi-chevron-right"></i></button>
                </div>
            </div>
        </div>
    );
};

export default BPaginate;
